"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitSecret20ViewingKeyPermissionType = exports.isSecret20ViewingKeyPermissionType = exports.getSecret20ViewingKeyPermissionType = void 0;
function getSecret20ViewingKeyPermissionType(contractAddress) {
    return `viewing-key/${contractAddress}`;
}
exports.getSecret20ViewingKeyPermissionType = getSecret20ViewingKeyPermissionType;
function isSecret20ViewingKeyPermissionType(type) {
    return type.startsWith("viewing-key/");
}
exports.isSecret20ViewingKeyPermissionType = isSecret20ViewingKeyPermissionType;
function splitSecret20ViewingKeyPermissionType(type) {
    return type.replace("viewing-key/", "");
}
exports.splitSecret20ViewingKeyPermissionType = splitSecret20ViewingKeyPermissionType;
//# sourceMappingURL=types.js.map